import React from "react";
import '../../assets/css/header+footer/Footer.css';
import escLogo from '../../assets/images/icons/esc6-logo.png'


const Footer = () => {
    return (
        <>
            <footer className="flex flexJustifySpaceBetween flexAlignCenter">
                <div className="flex">
                    <div className="flex flexColumn">
                        <a>LINK</a>
                        <a>LINK</a>
                        <a>LINK</a>
                        <a>LINK</a>
                        <a>LINK</a>
                    </div>
                    <div className="flex flexColumn">
                        <a>LINK</a>
                        <a>LINK</a>
                        <a>LINK</a>
                        <a>LINK</a>
                        <a>LINK</a>
                    </div>
                </div>
                <div>
                    <img alt="ESC Region 6 Logo" src={escLogo} />
                </div>

            </footer>
        </>
    );
}

export default Footer